import { alpha } from "@mui/material/styles";
import type { Theme as MuiTheme } from "@mui/material/styles";
import { type IntlShape } from "react-intl";

import { type MachineGroupStatus } from "@/schemas";

export const getMachineGroupStatusColor = (status: MachineGroupStatus, theme: MuiTheme): string => {
	const normalizedStatus = status.toLowerCase().trim();

	switch (normalizedStatus) {
		case "online":
			return alpha(theme.palette.success.main, 0.1);
		case "offline":
		case "nomachinesconfigured":
			return alpha(theme.palette.text.disabled, 0.1);
		case "error":
			return alpha(theme.palette.error.main, 0.1);
		case "initializing":
			return alpha(theme.palette.common.white, 0.1);
		case "paused":
		case "changingcorrugate":
		case "changing corrugate":
			return alpha(theme.palette.warning.main, 0.1);
		default:
			return alpha(theme.palette.common.white, 0.1);
	}
};

export const getMachineGroupStatusMessage = (status: MachineGroupStatus, intl: IntlShape) => {
	const normalizedStatus = status.toLowerCase().trim();

	switch (normalizedStatus) {
		case "changingcorrugate":
		case "changing corrugate":
			return intl.formatMessage({
				id: "Changing Z-Fold",
				defaultMessage: "Changing Z-Fold",
			});
		case "error":
			return intl.formatMessage({
				id: "Error",
				defaultMessage: "Error",
			});
		case "initializing":
			return intl.formatMessage({
				id: "Initializing",
				defaultMessage: "Initializing",
			});
		case "machineservice":
			return intl.formatMessage({
				id: "Machine Service Mode",
				defaultMessage: "Machine Service Mode",
			});
		case "nomachinesconfigured":
			return intl.formatMessage({
				id: "Offline (No Machines Configured)",
				defaultMessage: "Offline (No Machines Configured)",
			});
		case "offline":
			return intl.formatMessage({
				id: "Offline",
				defaultMessage: "Offline",
			});
		case "online":
			return intl.formatMessage({
				id: "Online",
				defaultMessage: "Online",
			});
		case "paused":
			return intl.formatMessage({
				id: "Paused",
				defaultMessage: "Paused",
			});
		case "service":
			return intl.formatMessage({
				id: "Service",
				defaultMessage: "Service",
			});
		case "unknownmachinegroupstatus":
			return intl.formatMessage({
				id: "Unknown",
				defaultMessage: "Unknown",
			});
		case "airplanemode":
			return intl.formatMessage({
				id: "Offline Mode",
				defaultMessage: "Offline Mode",
			});
		default:
			return intl.formatMessage({
				id: "Unknown",
				defaultMessage: "Unknown",
			});
	}
};
